export const en = {
  'shell.nav.recognition': 'Recognition',

  'recognition.title': 'Recognition',
  'recognition.description': 'Awards for people who stood out, and thank-yous between colleagues.',

  'recognition.awards.title': 'Awards',
  'recognition.awards.give': 'Give an award',
  'recognition.awards.empty': 'No awards yet',
  'recognition.awards.emptyHint': 'Pick the person who stood out this month. Staff see the award on their home screen, and you can also show it on the gym site.',
  'recognition.awards.edit': 'Edit the award “{title}”',
  'recognition.awards.delete': 'Delete the award “{title}”',
  'recognition.awards.deleteTitle': 'Delete this award?',
  'recognition.awards.deleteHint': 'The award and its picture are removed. This cannot be undone.',
  'recognition.awards.deleted': 'Award deleted',
  'recognition.awards.created': 'Award given',
  'recognition.awards.saved': 'Award saved',
  'recognition.awards.onTrainerPage': 'Also on the trainer’s page',
  'recognition.awards.visibility.STAFF': 'Staff only',
  'recognition.awards.visibility.PUBLIC': 'On the gym site',
  'recognition.awards.latest': 'Latest award',

  'recognition.award.createTitle': 'Give an award',
  'recognition.award.editTitle': 'Edit the award',
  'recognition.award.description': 'Staff see every award. Mark it public to show it on the gym site as well.',
  'recognition.award.employee': 'Employee',
  'recognition.award.chooseEmployee': 'Choose an employee',
  'recognition.award.employeeRequired': 'Choose who the award is for',
  'recognition.award.title': 'Title',
  'recognition.award.titlePlaceholder': 'Employee of the month',
  'recognition.award.titleKa': 'Title in Georgian',
  'recognition.award.titleRequired': 'Give the award a title',
  'recognition.award.period': 'Given for',
  'recognition.award.periodMonth': 'A month',
  'recognition.award.periodDay': 'A day',
  'recognition.award.month': 'Month',
  'recognition.award.day': 'Day',
  'recognition.award.periodRequired': 'Choose the month or the day',
  'recognition.award.reason': 'Reason',
  'recognition.award.reasonKa': 'Reason in Georgian',
  'recognition.award.visibility': 'Who sees it',
  'recognition.award.publicHint': 'A public award shows the name, title, reason and picture on your gym site, and on the trainer’s page when the employee is a trainer.',
  'recognition.award.staffHint': 'A staff-only award is seen by your team in Bulk and never on the website.',
  'recognition.award.picture': 'Picture',
  'recognition.award.pictureChoose': 'Choose a picture',
  'recognition.award.pictureReplace': 'Replace the picture',
  'recognition.award.pictureRemove': 'Remove the picture',
  'recognition.award.pictureHint': 'JPEG, PNG or WebP. Changing who sees the award removes its picture, so add it again afterwards.',
  'recognition.award.pictureChanged': 'Picture will be removed',

  'recognition.kudos.title': 'Kudos',
  'recognition.kudos.send': 'Send kudos',
  'recognition.kudos.empty': 'No kudos yet',
  'recognition.kudos.emptyHint': 'Thank a colleague who helped you. It shows here for the whole team.',
  'recognition.kudos.sent': 'Kudos sent',
  'recognition.kudos.mine': 'You sent this',
  'recognition.kudos.forMe': 'For you',
  'recognition.kudos.hidden': 'Hidden',
  'recognition.kudos.hiddenBy': 'Hidden by {name} on {date}',
  'recognition.kudos.hide': 'Hide',
  'recognition.kudos.unhide': 'Show again',
  'recognition.kudos.hideTitle': 'Hide this kudo?',
  'recognition.kudos.hideHint': 'Only managers will still see it. Everyone else stops seeing it at once.',
  'recognition.kudos.wasHidden': 'Kudo hidden',
  'recognition.kudos.wasShown': 'Kudo shown again',
  'recognition.kudos.dialogTitle': 'Say thanks',
  'recognition.kudos.dialogDescription': 'Your message appears in the kudos feed that every colleague sees.',
  'recognition.kudos.to': 'Colleague',
  'recognition.kudos.chooseColleague': 'Choose a colleague',
  'recognition.kudos.toRequired': 'Choose who to thank',
  'recognition.kudos.message': 'Message',
  'recognition.kudos.messagePlaceholder': 'Thanks for covering my shift!',
  'recognition.kudos.messageRequired': 'Write a short message',
  'recognition.kudos.counter': '{count} / {max}',

  'recognition.card.title': 'Recognition',
  'recognition.card.open': 'Open',

  'admin.apiError.AWARD_PERIOD': 'Give a month or a day for the award, not both.',
  'admin.apiError.KUDOS_TO_SELF': 'Thank a colleague, not yourself.',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.recognition': 'აღიარება',

  'recognition.title': 'აღიარება',
  'recognition.description': 'ჯილდოები გამორჩეული თანამშრომლებისთვის და მადლობები კოლეგებს შორის.',

  'recognition.awards.title': 'ჯილდოები',
  'recognition.awards.give': 'ჯილდოს გადაცემა',
  'recognition.awards.empty': 'ჯილდოები ჯერ არ არის',
  'recognition.awards.emptyHint': 'აირჩიეთ ადამიანი, რომელიც ამ თვეში გამოირჩეოდა. თანამშრომლები ჯილდოს მთავარ გვერდზე ნახავენ, სურვილისამებრ კი ის საიტზეც გამოჩნდება.',
  'recognition.awards.edit': 'ჯილდოს „{title}“ რედაქტირება',
  'recognition.awards.delete': 'ჯილდოს „{title}“ წაშლა',
  'recognition.awards.deleteTitle': 'წავშალოთ ეს ჯილდო?',
  'recognition.awards.deleteHint': 'ჯილდო და მისი სურათი წაიშლება. ამის გაუქმება შეუძლებელია.',
  'recognition.awards.deleted': 'ჯილდო წაიშალა',
  'recognition.awards.created': 'ჯილდო გადაცემულია',
  'recognition.awards.saved': 'ჯილდო შენახულია',
  'recognition.awards.onTrainerPage': 'ტრენერის გვერდზეც',
  'recognition.awards.visibility.STAFF': 'მხოლოდ პერსონალისთვის',
  'recognition.awards.visibility.PUBLIC': 'საიტზე',
  'recognition.awards.latest': 'ბოლო ჯილდო',

  'recognition.award.createTitle': 'ჯილდოს გადაცემა',
  'recognition.award.editTitle': 'ჯილდოს რედაქტირება',
  'recognition.award.description': 'ყველა ჯილდოს პერსონალი ხედავს. საჯაროდ მონიშვნის შემთხვევაში ის დარბაზის საიტზეც გამოჩნდება.',
  'recognition.award.employee': 'თანამშრომელი',
  'recognition.award.chooseEmployee': 'აირჩიეთ თანამშრომელი',
  'recognition.award.employeeRequired': 'აირჩიეთ, ვის ეკუთვნის ჯილდო',
  'recognition.award.title': 'სათაური',
  'recognition.award.titlePlaceholder': 'თვის თანამშრომელი',
  'recognition.award.titleKa': 'სათაური ქართულად',
  'recognition.award.titleRequired': 'მიუთითეთ ჯილდოს სათაური',
  'recognition.award.period': 'რისთვისაა',
  'recognition.award.periodMonth': 'თვე',
  'recognition.award.periodDay': 'დღე',
  'recognition.award.month': 'თვე',
  'recognition.award.day': 'დღე',
  'recognition.award.periodRequired': 'აირჩიეთ თვე ან დღე',
  'recognition.award.reason': 'მიზეზი',
  'recognition.award.reasonKa': 'მიზეზი ქართულად',
  'recognition.award.visibility': 'ვინ ხედავს',
  'recognition.award.publicHint': 'საჯარო ჯილდო საიტზე ჩანს სახელით, სათაურით, მიზეზითა და სურათით, ხოლო თუ თანამშრომელი ტრენერია, ტრენერის გვერდზეც.',
  'recognition.award.staffHint': 'მხოლოდ პერსონალისთვის განკუთვნილ ჯილდოს თქვენი გუნდი ხედავს Bulk-ში, ვებსაიტზე კი ის არასდროს ჩანს.',
  'recognition.award.picture': 'სურათი',
  'recognition.award.pictureChoose': 'აირჩიეთ სურათი',
  'recognition.award.pictureReplace': 'სურათის შეცვლა',
  'recognition.award.pictureRemove': 'სურათის წაშლა',
  'recognition.award.pictureHint': 'JPEG, PNG ან WebP. ჯილდოს ხილვადობის შეცვლისას სურათი იშლება, ამიტომ შემდეგ ის თავიდან დაამატეთ.',
  'recognition.award.pictureChanged': 'სურათი წაიშლება',

  'recognition.kudos.title': 'მადლობები',
  'recognition.kudos.send': 'მადლობის გაგზავნა',
  'recognition.kudos.empty': 'მადლობები ჯერ არ არის',
  'recognition.kudos.emptyHint': 'მადლობა გადაუხადეთ კოლეგას, რომელმაც დაგეხმარათ. ეს მთელ გუნდს გამოუჩნდება.',
  'recognition.kudos.sent': 'მადლობა გაგზავნილია',
  'recognition.kudos.mine': 'თქვენ გაგზავნეთ',
  'recognition.kudos.forMe': 'თქვენთვის',
  'recognition.kudos.hidden': 'დამალულია',
  'recognition.kudos.hiddenBy': 'დამალა {name}, {date}',
  'recognition.kudos.hide': 'დამალვა',
  'recognition.kudos.unhide': 'ხელახლა ჩვენება',
  'recognition.kudos.hideTitle': 'დავმალოთ ეს მადლობა?',
  'recognition.kudos.hideHint': 'მას მხოლოდ მენეჯერები დაინახავენ. დანარჩენებისთვის ის მაშინვე გაქრება.',
  'recognition.kudos.wasHidden': 'მადლობა დამალულია',
  'recognition.kudos.wasShown': 'მადლობა ისევ ჩანს',
  'recognition.kudos.dialogTitle': 'მადლობის გადახდა',
  'recognition.kudos.dialogDescription': 'თქვენი შეტყობინება მადლობების ლენტაში გამოჩნდება, რომელსაც ყველა კოლეგა ხედავს.',
  'recognition.kudos.to': 'კოლეგა',
  'recognition.kudos.chooseColleague': 'აირჩიეთ კოლეგა',
  'recognition.kudos.toRequired': 'აირჩიეთ, ვის უხდით მადლობას',
  'recognition.kudos.message': 'შეტყობინება',
  'recognition.kudos.messagePlaceholder': 'გმადლობთ, რომ ჩემი ცვლა შემცვალეთ!',
  'recognition.kudos.messageRequired': 'დაწერეთ მოკლე შეტყობინება',
  'recognition.kudos.counter': '{count} / {max}',

  'recognition.card.title': 'აღიარება',
  'recognition.card.open': 'გახსნა',

  'admin.apiError.AWARD_PERIOD': 'ჯილდოსთვის მიუთითეთ თვე ან დღე, ორივე ერთად არა.',
  'admin.apiError.KUDOS_TO_SELF': 'მადლობა კოლეგას გადაუხადეთ და არა საკუთარ თავს.',
};
